import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { useState, useEffect, lazy, Suspense } from 'react';
import Home from './pages/Home';
import NavbarAudioMonitor from './components/NavbarAudioMonitor';
import { recordPageVisit } from './utils/telemetry';
import './App.css';

const About = lazy(() => import('./pages/About'));
const Writings = lazy(() => import('./pages/Writings'));
const WritingDetail = lazy(() => import('./pages/WritingDetail'));
const Projects = lazy(() => import('./pages/Projects'));
const Bookshelf = lazy(() => import('./pages/Bookshelf'));
const BookDetail = lazy(() => import('./pages/BookDetail'));
const Contact = lazy(() => import('./pages/Contact'));
const Stats = lazy(() => import('./pages/Stats'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));

function RouteTelemetryTracker() {
  const location = useLocation();
  useEffect(() => {
    recordPageVisit(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  const [adminToken, setAdminToken] = useState<string | null>(localStorage.getItem('adminToken'));

  const handleLogin = (token: string) => {
    localStorage.setItem('adminToken', token);
    setAdminToken(token);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    setAdminToken(null);
  };

  return (
    <BrowserRouter>
      <RouteTelemetryTracker />
      <nav className="nav-bar">
        <Link to="/">~</Link>
        <Link to="/about">About</Link>
        <Link to="/writings">Writings</Link>
        <Link to="/projects">Projects</Link>
        <Link to="/bookshelf">Bookshelf</Link>
        <Link to="/contact">CV</Link>
        <Link to="/stats">Stats</Link>
        <NavbarAudioMonitor />
      </nav>

      <main className="content-area">
        <Suspense fallback={<div className="terminal-box">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/writings" element={<Writings />} />
            <Route path="/writings/:id" element={<WritingDetail />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/bookshelf" element={<Bookshelf />} />
            <Route path="/bookshelf/:id" element={<BookDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/stats" element={<Stats />} />
            <Route path="/admin" element={
              adminToken 
                ? <AdminDashboard token={adminToken} onLogout={handleLogout} /> 
                : <AdminLogin onLogin={handleLogin} />
            } />
          </Routes>
        </Suspense>
      </main>
    </BrowserRouter>
  );
}

export default App;
